export default {"src":"/uk/_next/static/media/spot-checking-details.9b0300c0.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};